<template>
    <LayoutSub className="business_unit">
        <SubSection classList="pb-0">
            <h1>
                한국정보통신의 지속적인 성장을 견인하고 <br />
                미래 성장동력을 발굴하는 <strong class="c-red">디지털기획팀</strong>
            </h1>
            <p>
                디지털기획팀은 회사의 지속적인 성장 및 비전 달성을 위하여, 기존 사업분야의 틀을 넘어 미래의 성장 동력이 될 신규 사업기회를 발굴하고
                추진하는 역할을 담당하고 있습니다. <br />
                신규 산업과 기술 및 시장 동향에 대한 조사, 사업 아이템 발굴, 비즈니스 모델 수립 및 특허 개발, 신규사업 추진 및 운영, 부가서비스 개발
                및 운영 등이 디지털기획팀의 주요 업무입니다.<br />
                한국정보통신의 미래를 책임질 디지털기획팀에서는 새로운 것에 대한 도전적인 자세와 다양한 사물 및 현상에 대한 융합적인 사고를 가진
                인재를 기다리고있습니다.
            </p>
            <img src="@/assets/digital_image01.png" alt="" />
        </SubSection>
        <SubSection classList="pt-160 pb-0">
            <h1>외국인관광객을 대상으로 <br class="mo-only"/>Total Solution을 제공하는 <strong class="c-red">FC사업팀</strong></h1>
            <p>
                FC사업팀의 FC는 Foreign Customer를 의미합니다. <br />
                외국인들이 한국에서 편리하게 생활할 수 있도록 다양한 결제수단 및 부가 서비스를 제공하자는 의미입니다. <br />
                <br />
                FC사업팀은 AOS(Alipay Off/Online Payment Service), WOS(Wechat Off/Online Payment Service), LOS(LINE Offline Payment Service) <br class="pc-only"/>
                그리고 TRS(Tax Refund Service) 등의 서비스를 전국 가맹점에 제공하고 있습니다.<br />
                <br />
                현재 다양한 국가의 외국인 관광객들을 대상으로 결제 및 부가서비스를 제공하고 있으며 이외 해외 유명 글로벌 핀테크 기업과의 제휴도
                진행중에 있습니다. <br />
                이후 외국인관광객들을 위한 Total Solution을 통해 고객의 편의성을 더욱 증대할 계획입니다.
            </p>
            <img src="@/assets/digital_image02.png" alt="" />
        </SubSection>
    </LayoutSub>
</template>
<script>
import SubSection from '@/components/SubSection.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';

export default {
    components: {
        LayoutSub,
        SubSection,
    },
};
</script>